import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config/api.config';

const API_BASE = API_BASE_URL;

export function useCompatGuard() {
  const [ok, setOk] = useState(true);
  const [info, setInfo] = useState(null);
  const reqApi = import.meta.env.VITE_REQUIRED_API_VERSION;
  const reqSchema = import.meta.env.VITE_REQUIRED_SCHEMA_VERSION;

  useEffect(() => {
    let mounted = true;
    
    // Non-blocking: compat check should not prevent app from loading
    fetch(`${API_BASE}/api/compat`)
      .then((r) => {
        if (!r.ok) {
          throw new Error(`HTTP ${r.status}: ${r.statusText}`);
        }
        return r.json();
      })
      .then((c) => {
        if (!mounted) return;
        setInfo(c);
        const match = (!reqApi || c.api === reqApi) && (!reqSchema || c.schema === reqSchema);
        setOk(match);
      })
      .catch((error) => {
        if (mounted) {
          // Log warning but don't block app - allow it to continue
          console.warn('[useCompatGuard] Compat check failed (non-blocking):', {
            error: error.message || String(error),
            apiBase: API_BASE,
          });
          // Non-blocking: allow app to continue even if compat check fails
          setOk(true);
        }
      });
    return () => {
      mounted = false;
    };
  }, [reqApi, reqSchema]);

  return { ok, info };
}
